<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.COMMON.SELECT_TYPE' | translate }}</h2>
<mat-dialog-content>
  <mat-form-field class="full-width">
    <mat-label>{{ 'FRONTEND.SALES_UI.PIPELINE.TYPE_LABEL' | translate }}</mat-label>
    <mat-select
      (selectionChange)="setTypes($event.value)"
      [compareWith]="typeIdComparison"
      [value]="checkedTypes$ | async"
      multiple
    >
      <mat-option *ngFor="let type of availableTypes$ | async" [value]="type">{{ type.displayName }}</mat-option>
    </mat-select>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button color="primary" mat-button mat-dialog-close>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="save()" color="primary" mat-raised-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
